import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./thin.woff2%22,%22weight%22:%22100%22,%22style%22:%22normal%22},{%22path%22:%22./light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22./regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./semi-bold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./extra-bold.woff2%22,%22weight%22:%22800%22,%22style%22:%22normal%22},{%22path%22:%22./black.woff2%22,%22weight%22:%22900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22}],%22variableName%22:%22AxiformaFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'AxiformaFont', 'AxiformaFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
